<template lang="pug" src="./notification.pug"></template>
<style lang="scss" src="./notification.scss" scoped></style>

<script>
import { mapGetters, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import scroll from '@/utils/scroll'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        dropdown: false,
        resultShow: false
    }),
    validations: {
        notification: {
            title: {
                required
            },
            body: {
                maxLength: function() {
                    return this.notification.body.length <= this.imageFilled
                }
            },
            phoneFilters: {
            }
        }
    },
    computed: {
        ...mapGetters(['type']),
        ...mapState({
            filters: state => state.notification.filters,
            notification: state => state.notification.notification,
            count: state => state.notification.count,
            clients: state => state.notification.clients,
            normalizePhones: state => state.notification.normalizePhones,
            result: state => state.notification.result,
            isLoaded: state => state.notification.isLoaded
        }),
        isDisabled: function() {
            return !!this.filters.phones.length
        },
        showPhoneEditor() {
            return this.filters.sendTo === 'selected'
        },
        messageForm: function() {
            return this.filters.sendTo !== 'selected' || (this.normalizePhones && this.normalizePhones.success &&
                this.normalizePhones.success.length)
        },
        androidErrors() {
            return Object.entries(this.result.android.errors).map(([key, value]) => ({ key, value }))
        },
        iosErrors() {
            return Object.entries(this.result.ios.errors).map(([key, value]) => ({ key, value }))
        },
        filterPhones() {
            return this.filters.phones && this.filters.phones.split('\n').filter(it => !!it)
        },
        imageFilled() {
            // If image field was filled we limit notification body to 50 symbols,
            // because when image send - text was overlaid
            return this.notification.image ? 50 : 255
        }
    },
    created: function() {
        this.getClientList(this.filters.sendTo)
    },
    methods: {
        getClientList(scope) {
            this.$store.dispatch('notification/getClients', scope)
        },
        setSendTo(val) {
            this.$store.commit('notification/SET_SELECTION', val)

            this.getClientList(val)
        },
        async sendPushNotification() {
            if (this.isLoaded) {
                return
            }

            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                await this.$store.dispatch('notification/sendPushNotification')

                this.$nextTick(() => {
                    this.$v.$reset()
                    this.resultShow = true
                    setTimeout(() => {
                        scroll(this.$refs.resultCard)
                    }, 100)
                })
            }
        },
        validatePhones() {
            this.resultShow = false

            if (this.$v.notification.phoneFilters.$invalid) {
                this.$v.notification.phoneFilters.$touch()
                return
            }

            if (!this.filterPhones.length) {
                this.$store.commit('notification/SET_COUNT', 0)
            }
            this.$store.dispatch('notification/validatePhones', this.filterPhones)
        }
    }
}
</script>
